define('model/LicenseModel',['require','lib/model/BaseModel'],function (require) {

    var BaseModel = require('lib/model/BaseModel');

    /**
     * Day info model
     *
     * @class DayModel
     */
    return BaseModel.extend({

        defaults: {
            license_text: '',
            license_label: ''
        },
        
        fetchLanguage: function(lang) {
            return this.fetch({
                url: _.result(this, 'url') + '?lang=' + lang
            });
        }

    });

});
